import { flatten, uniq, values } from "lodash";

import { AnsweredQuestion, AnsweredQuestionWithId } from "../model";

import { QuestionnaireState } from "./model";

export const getAnswerToQuestionWithId = (questions: AnsweredQuestionWithId[], questionId: string) => {
    return (questions ?? []).find(question => question.id === questionId)?.answer;
};

export const getQuestionsFromQuestionnaire = (questionnaire: QuestionnaireState) => {
    return questionnaire ? uniq(flatten(questionnaire.sections.map(section => values(section.questions)))) : [];
};

export const hasQuestionWithId = (questions: AnsweredQuestionWithId[], questionId: string) => {
    return (questions ?? []).find(question => question.id === questionId);
};

export interface UpdateAnswer {
    sectionId: string;
    id: string;
    question: AnsweredQuestion;
}
